<template>
  <div id="document-actionbar-path-view">
    <!-- パンくずリスト -->
    <div id="breadcrumb-path-view" class="mx-2 flex flex-wrap">
      <div
        class="path-item mr-2 my-1 flex cursor-pointer align-middle"
        @click="toggleRootPath"
        :class="{ active: pathItems.length === 0 }"
      >
        <feather-icon svgClasses="h-6 w-6" icon="FolderIcon"></feather-icon>
        <span class="pl-2">{{ vesselName }}</span>
      </div>

      <div
        v-for="(item, index) in pathItems"
        :key="index"
        class="flex flex-wrap my-1"
      >
        <div class="mr-2 flex w-4">
          <feather-icon
            class="path-icon"
            svgClasses="h-4 w-4"
            icon="ChevronRightIcon"
          ></feather-icon>
        </div>
        <div
          class="path-item mr-2 flex cursor-pointer break-all"
          :class="{ active: index === pathItems.length - 1 }"
          @click="toggleMovePath(index)"
        >
          <vx-tooltip
            class="folder-name-tooltip max-w-xl2 truncate ... break-all"
            :text="item.name"
          >
            {{ item.name }}
          </vx-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";

const {
  mapActions: mapActionsOfenterpriseDocumentManager,
  mapMutations: mapMutationsOfenterpriseDocumentManager,
  mapState: mapStateOfenterpriseDocumentManager
} = createNamespacedHelpers("enterpriseDocumentManager");


export default {
  mixins: [ColorMixin],
  data () {
    return {
    }
  },
  computed: {
    ...mapStateOfenterpriseDocumentManager([
      "currentPath",
      "vesselName",
      "documentRootPath"
    ]),
    pathItems: {
      get () { return this.currentPath },
      set (items) {
        this.SET_CURRENT_PATH(items)
      }
    },
  },
  watch: {
    pathItems (items) {
      this.SET_CURRENT_PATH(items)
    },
    async currentPath () {
      await this.reloadDocuments()
    }
  },
  methods: {
    ...mapActionsOfenterpriseDocumentManager(["reloadDocuments"]),
    ...mapMutationsOfenterpriseDocumentManager([
      "SET_CURRENT_PATH",
      "RESET_CURRENT_PATH",
      "RESET_SELECTED_DOCUMENTS",
      "RESET_DOCUMENT_SEARCH",
      "SET_SELECTED_SIDEBAR_ITEM"
    ]),
    toggleRootPath () {
      this.SET_SELECTED_SIDEBAR_ITEM("tree-root");
      this.RESET_CURRENT_PATH();
      this.updatePath();
    },
    toggleMovePath (index) {
      if (this.pathItems.length === index + 1) { return }
      this.pathItems = this.pathItems.slice(0, index + 1)
      const path = `${this.documentRootPath}${this.pathItems.map(e => e.name).join("/")}`
      this.SET_SELECTED_SIDEBAR_ITEM(path);
      this.updatePath();
    },
    updatePath () {
      this.RESET_SELECTED_DOCUMENTS();
      this.RESET_DOCUMENT_SEARCH();
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#document-actionbar-path-view {
  color: $aisea_blue;

  .folder-name-tooltip {
    max-width: 300px;
  }

  .disabled-link {
    color: $aisea-pink;
  }

  a {
    color: $aisea-blue;
  }

  .path-icon {
    color: $aisea-gray;
  }

  #breadcrumb-path-view {
    .path-item:hover {
      color: $aisea-gray;
    }

    .active {
      color: $aisea-gray;
    }
  }
}
</style>